require('./bootstrap');
require('leaflet');
import MatchHeight from '@tannerhodges/match-height';

import {createApp} from "vue";

const app = createApp({});

import Kontakt from './components/Kontakt.vue';
import Joblist from './components/joblist/Joblist.vue';
import JobApplication from './components/jobdetail/JobApplication.vue';
import MessageModal from './components/jobdetail/MessageModal.vue';
import LatestJobs from './components/joblist/LatestJobs.vue';


app.component('kontakt', Kontakt);
app.component('joblist', Joblist);
app.component('job-application', JobApplication);
app.component('message-modal', MessageModal);
app.component('latest-jobs', LatestJobs);


if (document.querySelector('#vue')) {
  app.mount('#vue');
}
// Comment in for Checking Remove from Doc before Deploy
// import cssCheck from './unusedCSS.js'
// cssCheck();


